import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RemoveNonDigitPipe } from "../pipes/remove-non-digit.pipe";
import { FilterEmailDomainPipe } from "./filterEmailDomain.pipe";
import { HiddenCPFPipe } from "./hidden-cpf.pipe";
import { NormalizeImagePipe } from "./normalize-image.pipe";
import { FormatCurrencyPipe } from "./formatCurrency.pipe";
import { FormatPercentPipe } from "./formatPercent.pipe";
import { FormatPhoneNumberPipe } from "./formatPhoneNumber.pipe";
@NgModule({
    declarations: [
        RemoveNonDigitPipe,
        FilterEmailDomainPipe,
        HiddenCPFPipe,
        NormalizeImagePipe,
        FormatCurrencyPipe,
        FormatPercentPipe,
        FormatPhoneNumberPipe,
    ],
    imports: [CommonModule],
    providers: [RemoveNonDigitPipe, FilterEmailDomainPipe, HiddenCPFPipe,FormatCurrencyPipe,FormatPhoneNumberPipe,
        FormatPercentPipe,],
    exports: [
        RemoveNonDigitPipe,
        FilterEmailDomainPipe,
        HiddenCPFPipe,
        NormalizeImagePipe,
        FormatCurrencyPipe,
        FormatPercentPipe,
        FormatPhoneNumberPipe
    ],
})
export class CustomPipesModule {}
